import React from "react";
import styled from "styled-components";

import Sparkline from "../common/Sparkline";
import { PIVOT_COLOR } from "../common/trafficEstimates";
import { formatDay } from "./dates";

/** How much the chart shows around the issue's start, as days either side. */
export const ZOOMS = [
    { key: "1m", label: "1 month", days: 15 },
    { key: "3m", label: "3 months", days: 45 },
    { key: "6m", label: "6 months", days: 91 },
    { key: "12m", label: "12 months", days: 182 },
];
export const DEFAULT_ZOOM = "6m";

const LINE_COLOR = "#818cf8";

/** The page's daily figure over `around` days either side of the issue's start. */
const daysAround = (since, spark, days, around) => {
    const start = days.indexOf(since);
    const first = Math.max(0, start - around);
    return days.slice(first, start + around + 1).map((day, index) => ({ day, v: spark[first + index] }));
};

/** The row's chart: the page's daily figure around the issue's start, the start dashed, and Pettitt's change point where it found one. */
export default function IssueChart({ since, reading, spark, days, name, around }) {
    if (!spark) return <Muted>no {name.toLowerCase()} recorded</Muted>;
    if (!days.includes(since)) return <Muted>started before the last 12 months</Muted>;
    const HoverBox = ({ day, v }) => (
        <Box>
            <Day>{formatDay(day)}</Day>
            <Row><Dot /><span>{name}</span><Value>{v == null ? "–" : whole.format(v)}</Value></Row>
            <Row><Dashed /><span>Issue started</span><Value>{formatDay(since)}</Value></Row>
        </Box>
    );
    return (
        <Zoom>
            <Sparkline data={daysAround(since, spark, days, around)} color={LINE_COLOR} markers={[since]} fromZero scale tooltip={HoverBox}
                points={reading?.pivot ? [{ day: reading.pivot.day, color: PIVOT_COLOR }] : []} />
        </Zoom>
    );
}

const whole = new Intl.NumberFormat("en-GB", { maximumFractionDigits: 0 });

const Box = styled.div`
    background: #fff;
    border: 1px solid #e2e8f0;
    border-radius: 8px;
    padding: 10px 14px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
    font-size: 0.76rem;
    min-width: 180px;
`;

const Day = styled.div`
    font-size: 0.72rem;
    font-weight: 700;
    color: #0f172a;
    margin-bottom: 6px;
`;

const Row = styled.div`
    display: flex;
    align-items: center;
    gap: 6px;
    color: #374151;
    margin-bottom: 3px;
`;

const Value = styled.span`
    margin-left: auto;
    padding-left: 12px;
    font-weight: 600;
    color: #0f172a;
`;

const Dot = styled.span`
    width: 8px;
    height: 8px;
    border-radius: 50%;
    flex-shrink: 0;
    background: ${LINE_COLOR};
`;

const Dashed = styled.span`
    height: 11px;
    flex-shrink: 0;
    border-left: 1.5px dashed #e0776f;
    margin-left: 3px;
    width: 5px;
`;

const Zoom = styled.div`
    height: 40px;
`;

const Muted = styled.span`
    font-size: 0.68rem;
    color: #94a3b8;
`;
